import React from 'react';
import { Container, Text, Box, Link } from '@chakra-ui/react';
import { LOCATION_DESCRIPTION, CIL } from './constants';
import logoMunlab from '../../images/logo-munlab.png';

const MUNLAB_YOUTUBE_ID = '_LKQ2r_Y3A0';
const MUNLAB_EMBED_URL = `https://www.youtube.com/embed/${MUNLAB_YOUTUBE_ID}?autoplay=1&mute=1&loop=1&playlist=${MUNLAB_YOUTUBE_ID}&controls=0&showinfo=0&modestbranding=1&playsinline=1`;

const LocationSection = () => (
  <Box
    as="section"
    id="section-munlab"
    position="relative"
    minH={{ base: '380px', md: '420px' }}
    overflow="hidden"
    borderRadius="xl"
    scrollMarginTop={{ base: '80px', md: '140px' }}
  >
    <Box
      position="absolute"
      top={0}
      left={0}
      w="100%"
      h="100%"
      overflow="hidden"
    >
      <iframe
        title="Munlab – video di sfondo"
        src={MUNLAB_EMBED_URL}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '100vw',
          height: '56.25vw',
          minHeight: '100%',
          minWidth: '177.78vh',
          transform: 'translate(-50%, -50%)',
        }}
      />
    </Box>
    <Box
      position="absolute"
      top={0}
      left={0}
      w="100%"
      h="100%"
      bg="rgba(255, 204, 0, 0.35)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      color="white"
    >
      <Container maxW="container.md" px={{ base: 4, md: 6 }} textAlign="center">
        <Box
          as="img"
          src={logoMunlab}
          alt="Ecomuseo dell'argilla Munlab"
          maxH={{ base: '48px', md: '56px' }}
          h="auto"
          w="auto"
          objectFit="contain"
          mb={4}
          mx="auto"
          display="block"
        />
        <Text
          fontWeight="bold"
          mb={4}
          fontSize={{ base: 'md', md: 'lg' }}
          color="white"
        >
          Il centro estivo si svolge presso il Munlab, Ecomuseo
          dell&apos;argilla.
        </Text>
        <Text fontWeight="bold" mb={4} fontSize={{ base: 'sm', md: 'md' }}>
          {LOCATION_DESCRIPTION}
        </Text>
        <Link
          href="https://www.munlabtorino.it/"
          isExternal
          fontWeight="bold"
          color={CIL.yellow}
          _hover={{ textDecoration: 'underline' }}
        >
          Scopri di più sul Munlab…
        </Link>
      </Container>
    </Box>
  </Box>
);

export default LocationSection;
